import React from 'react';
import { CTAButton } from './CTAButton';
export function CostSection() {
  return <section className="w-full py-20 px-4 border-t" style={{
    backgroundColor: '#f8fafc',
    borderColor: '#e2e8f0'
  }} data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-4 text-center" style={{
        color: '#0f172a'
      }} data-id="element-31">
          El Costo de No Hacer Nada
        </h2>

        <div className="overflow-x-auto my-10" data-id="element-32">
          <table className="w-full border-collapse rounded-md overflow-hidden" data-id="element-33">
            <thead data-id="element-34">
              <tr style={{
              backgroundColor: '#0f172a'
            }} data-id="element-35">
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#f1f5f9'
              }} data-id="element-36">
                  ⏰ Tiempo Sin Actuar
                </th>
                <th className="text-left p-4 text-sm font-bold" style={{
                color: '#f59e0b'
              }} data-id="element-37">
                  💸 Dinero Que Nunca Llegó
                </th>
              </tr>
            </thead>
            <tbody data-id="element-38">
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-39">
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-40">
                  1 mes
                </td>
                <td className="p-4 font-bold" style={{
                color: '#0f172a'
              }} data-id="element-41">
                  2 - 6 millones
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} className="border-b" data-id="element-42">
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-43">
                  3 meses
                </td>
                <td className="p-4 font-bold" style={{
                color: '#0f172a'
              }} data-id="element-44">
                  6 - 18 millones
                </td>
              </tr>
              <tr className="bg-white border-b" style={{
              borderColor: '#e2e8f0'
            }} data-id="element-45">
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-46">
                  6 meses
                </td>
                <td className="p-4 font-bold" style={{
                color: '#0f172a'
              }} data-id="element-47">
                  12 - 36 millones
                </td>
              </tr>
              <tr style={{
              backgroundColor: '#f8fafc'
            }} data-id="element-48">
                <td className="p-4" style={{
                color: '#64748b'
              }} data-id="element-49">
                  1 año
                </td>
                <td className="p-4 font-bold" style={{
                color: '#dc2626'
              }} data-id="element-50">
                  24 - 72 millones
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-xs text-center mb-8" style={{
        color: '#94a3b8'
      }} data-id="element-51">
          Proyección basada en ejecución consistente. Los resultados varían.
        </p>

        <p className="text-lg mb-4 text-center" style={{
        color: '#64748b'
      }} data-id="element-52">
          Cada día que pasa sin tomar acción son millones de pesos que nunca
          llegaron a tu cuenta.
        </p>
        <p className="text-lg font-bold mb-12 text-center" style={{
        color: '#0f172a'
      }} data-id="element-53">
          No porque los perdiste — sino porque nunca llegaron.
        </p>

        <CTAButton text="NO QUIERO PERDER MÁS TIEMPO — ACCEDER A LA GUÍA AHORA" subtitle="✅ Solo $49.999 · ✅ Primera página en menos de 1 hora · ✅ Garantía de 30 días" scrollTo="ebook-main" data-id="element-54" />
      </div>
    </section>;
}